import * as React from 'react';
import type { SVGProps } from 'react';
import { chakra } from '@chakra-ui/react';
const SvgIconUnlockGg = chakra((props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={18}
    height={17}
    fill="none"
    viewBox="0 0 18 17"
    aria-hidden="true"
    {...props}
  >
    <path
      fill="url(#icon-unlock-gg_svg__a)"
      d="M13.938 1.031C16.28 1.25 18 3.375 18 5.72V7.5c0 .281-.25.5-.5.5h-1a.494.494 0 0 1-.5-.5V5.656c0-1.312-.969-2.5-2.25-2.625A2.49 2.49 0 0 0 11 5.5V8h1c1.094 0 2 .906 2 2v5c0 1.125-.906 2-2 2H2c-1.125 0-2-.875-2-2v-5c0-1.094.875-2 2-2h7V5.5a4.494 4.494 0 0 1 4.938-4.469Z"
    />
    <defs>
      <linearGradient
        id="icon-unlock-gg_svg__a"
        x1={18}
        x2={2.11}
        y1={1}
        y2={18.876}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#6DF1E5" />
        <stop offset={0.18} stopColor="#4FC5BA" />
        <stop offset={0.73} stopColor="#26A69A" />
        <stop offset={1} stopColor="#1A746B" />
      </linearGradient>
    </defs>
  </svg>
));
export default SvgIconUnlockGg;
